import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { ADMIN } from "@/constants/testIds";

const AdminLogin = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        // Se já existe sessão válida (cookie httpOnly), pula direto pro admin.
        // O navegador envia o cookie automaticamente — não precisamos checar
        // o token aqui.
        api.get("/auth/me")
            .then(() => navigate("/admin", { replace: true }))
            .catch(() => {});
    }, [navigate]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);
        try {
            await api.post("/auth/login", { email, password });
            // Backend já gravou o cookie httpOnly; não precisamos guardar
            // nada no client. Apenas seguimos para o painel.
            navigate("/admin");
        } catch (err) {
            const d = err?.response?.data?.detail;
            setError(typeof d === "string" ? d : "Credenciais inválidas.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-[#0E2018] flex items-center justify-center px-6">
            <form
                onSubmit={handleSubmit}
                className="w-full max-w-sm flex flex-col gap-6"
            >
                <div>
                    <p className="text-[10px] uppercase tracking-[0.32em] text-[#7E8978] font-sans font-light mb-3">
                        Acesso restrito
                    </p>
                    <h1 className="font-serif font-light text-[26px] text-[#EAEAE6]">
                        Pensamento contínuo — administração
                    </h1>
                </div>
                <label className="flex flex-col gap-2">
                    <span className="text-[10px] uppercase tracking-[0.2em] text-[#7E8978] font-sans">
                        email
                    </span>
                    <input
                        type="email"
                        required
                        data-testid={ADMIN.loginEmail}
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        className="bg-transparent border-b border-[#234135] focus:border-[#EAEAE6] outline-none px-1 py-2 text-[#EAEAE6] font-sans"
                    />
                </label>
                <label className="flex flex-col gap-2">
                    <span className="text-[10px] uppercase tracking-[0.2em] text-[#7E8978] font-sans">
                        senha
                    </span>
                    <input
                        type="password"
                        required
                        data-testid={ADMIN.loginPassword}
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        className="bg-transparent border-b border-[#234135] focus:border-[#EAEAE6] outline-none px-1 py-2 text-[#EAEAE6] font-sans"
                    />
                </label>
                {error && (
                    <p className="font-sans font-light text-[12px] text-[#B0B6A6]">
                        {error}
                    </p>
                )}
                <button
                    type="submit"
                    data-testid={ADMIN.loginSubmit}
                    disabled={loading}
                    className="self-start inline-flex items-center gap-3 font-sans font-light text-[13px] tracking-[0.06em] uppercase text-[#EAEAE6] border-b border-[#234135] hover:border-[#EAEAE6] pb-2 transition-colors disabled:opacity-40"
                >
                    {loading ? "Entrando…" : "Entrar →"}
                </button>
            </form>
        </div>
    );
};

export default AdminLogin;
